var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaningMan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 759,
    viewBox: "0 0 304 759",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 42.5H149L161.5 36L173.5 33L177.5 42.5H187H197L204.5 38L198 28L187 15L179 7L170 8.5H161.5L155 15L149 21.5L140.5 29V42.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 42.5H149L161.5 36L173.5 33L177.5 42.5H187H197L204.5 38L198 28L187 15L179 7L170 8.5H161.5L155 15L149 21.5L140.5 29V42.5Z",
    fill: "url(#paint0_linear_15_97)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184 1.5L198 0L209.5 5L220.5 12.5L227 23.5L233 38.5V48V59.5L228.946 66.9317L227 80V70.5L228.946 66.9317L230.5 56.5V50.5L227 48L220.5 40.5L218 30.5L212 21L203.5 12.5L184 1.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M209.5 71.5H220.5L228 67.5L233 59.5L231 50L220.5 40.5V35L215 25.5L209.5 18L198.5 7.5L185 1L178.5 7.5L185 13.5L192 21L198.5 29L201.5 35L209.5 42.5L199 50V64L209.5 71.5Z",
    fill: "#359AA0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.5 71.5H220.5L228 67.5L233 59.5L231 50L220.5 40.5V35L215 25.5L209.5 18L198.5 7.5L185 1L178.5 7.5L185 13.5L192 21L198.5 29L201.5 35L209.5 42.5L199 50V64L209.5 71.5Z",
    fill: "url(#paint1_linear_15_97)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149 52.5V41.5L162 35.5L173 32.5L178 41.5L191 42.5L176 48.5L163.5 52.5H156.5L150 59.5L149 52.5Z",
    fill: "#A1665E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M233 88.5L228 79L231.5 62.5L220.5 70H209L199 62.5L206.5 44.5L180 55L168 59.5V67.5L163.5 70H156V79V88.5H163.5L168 95L173.5 101.5L180 111V117.5H189.5L191.5 111L194.5 122L197 129L188 141L197 151L204.5 141L211 130L221.5 117.5L229 107.5L236 99L233 88.5Z",
    fill: "#A1665E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150 59.5L145.5 67.5L150 75.5L156 70.5H161.5L169 67.5V59.5L181 54.5L194.5 50L205.5 45L210 42.5L205.5 37.5L169 50L158.5 52L154 54.5L150 59.5Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5 99L245 111L265 126L277 135.5L290 146.5L296.5 165.5V182.5V199.5V210.5L265 222L260.692 218L267 232L272.5 255.5L277 271.5L272.5 285L265 301.5L258 320.5L251.5 336.5L241 349.5L232 351.5H218.5H203.5L191.5 347L178.5 342L165 336.5L156.5 328L165 320.5L170 308.5V294L173.5 282V271.5L170 255.5L165 244.5V232L160.5 218L156.5 199.5V210.5H141.5H132.5L137 192L141.5 171L147.5 146.5V135.5L160.5 126L175.5 121.5L187 120.5L191.5 111L197 129L189.5 141L197 150L207 135.5L218.5 120.5L235.5 99Z",
    fill: "#FF005C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5 99L245 111L265 126L277 135.5L290 146.5L296.5 165.5V182.5V199.5V210.5L265 222L260.692 218L267 232L272.5 255.5L277 271.5L272.5 285L265 301.5L258 320.5L251.5 336.5L241 349.5L232 351.5H218.5H203.5L191.5 347L178.5 342L165 336.5L156.5 328L165 320.5L170 308.5V294L173.5 282V271.5L170 255.5L165 244.5V232L160.5 218L156.5 199.5V210.5H141.5H132.5L137 192L141.5 171L147.5 146.5V135.5L160.5 126L175.5 121.5L187 120.5L191.5 111L197 129L189.5 141L197 150L207 135.5L218.5 120.5L235.5 99Z",
    fill: "url(#paint2_linear_15_97)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M298.5 226.5L295 210L265.5 222L271 252.5L277 274.5L268.5 291.5L261 314L254.5 332.5L242 346L236.5 361L242 395L249.5 387L254.5 372L261 361L268.5 346L277 332.5L284.5 319.5L292 304.5L303.5 291.5V274.5V259.5L298.5 244.5V226.5Z",
    fill: "#A1665E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 233L138 210.5H156.5L158.5 213L160.5 222.5L161.5 230.5L160.5 239L156.5 253.5L154.5 264.5L151 271.5L146 276L140.5 279H135.5L123.5 267L111 250L104 239L98 229.5L95.5 224.5L91 218L81.5 208L76 205L73 204H70.5L67 203L69.5 202L70.5 200.5L71.5 198.5V196.5L73 195H74.5L77 193.5L79 192L81.5 190.5L84 189L86.5 188L88 186.5V184H85.5H84H81.5L80.5 182L81.5 180.5V178.5L80.5 176H79H76L70.5 170.5L71.5 169L70.5 167L69.5 165.5L67 164.5L62.5 158L70.5 156L73 158L80.5 165.5L88 174L97.5 192L108 205L132.5 233Z",
    fill: "#A1665E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43 149L41.5 151.5V152L44.5 155.5L48.5 160.5L53.5 167L55 169.5L59.5 176.5L60.5 179L66.5 186.5L68.5 189.5L79.5 186L81.5 184.5L81 183L76.5 175.5L74.5 174L72 171.5L68.5 165.5L65.5 162L62.5 158.5L59.5 155L57 151.5L55 149L52.5 147L50 145.5L47 147L45 147.5L43 149Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43 149L41.5 151.5V152L44.5 155.5L48.5 160.5L53.5 167L55 169.5L59.5 176.5L60.5 179L66.5 186.5L68.5 189.5L79.5 186L81.5 184.5L81 183L76.5 175.5L74.5 174L72 171.5L68.5 165.5L65.5 162L62.5 158.5L59.5 155L57 151.5L55 149L52.5 147L50 145.5L47 147L45 147.5L43 149Z",
    fill: "url(#paint3_linear_15_97)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 189L81.5 184.5L85 184H87.5V185.5L86.5 187.5L84.5 189L82.5 190L80.5 191L78.5 192.5L76.5 194L74.5 195H73L72 196.5L71 199L70 200.5L68 202.5L66.5 203H64.5L62 201.5L60.5 199L60 197L59 196.5V196L58 195L57 194V192.5L56 191L55 189V186.5L54.5 185.5L53.5 184.5L52.5 182L51.5 179.5V178L50.5 176.5L50 174V172.5L48 171L46 169.5L44 167.5V166L45.5 163.5L47 162L50 161H52.5L56 162L58 163.5L57 166L56 167.5H53.5L51.5 168.5L53.5 169.5L52.5 171.5L54.5 170L56 169.5L58 168.5L60.5 167.5L63 166H65H66.5L68 165L69.5 166L71 167.5L70.5 170L69.5 171L67.5 172.5L65.5 174H63.5L61.5 175L60 176L58 177L56 178.5L57 180L58 181.5L59 179.5H61.5L65 178.5L67.5 178L70 177L72 176.5L74 176H76.5H79.5L81 177L81.5 179.5L79.5 182H77L73 183.5H70.5L68 184.5L65 186L64 187.5L65 188.5L67.5 189Z",
    fill: "#A1665E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M268 373.5V346L262 355L259.5 363L254 373.5L248.5 388L240.5 392V386.5L238.5 368.5V358.5L240.5 349.5L230 350H218.5H204.5L190.5 346L175 339.5L164 335.5L157 326.5H152L144.5 339.5V355L138 373.5L127 404L117 432.5V444.5L140 457L162.5 462.5L175 432.5V408.5L178.5 394.5L181 404L178.5 419.5V438L166.5 459V476.5H178.5L203.5 483L226.5 488.5L233.5 476.5V465.5L238.5 444.5L246.5 419.5L254 400L268 386.5V373.5Z",
    fill: "#5F4B8B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M268 373.5V346L262 355L259.5 363L254 373.5L248.5 388L240.5 392V386.5L238.5 368.5V358.5L240.5 349.5L230 350H218.5H204.5L190.5 346L175 339.5L164 335.5L157 326.5H152L144.5 339.5V355L138 373.5L127 404L117 432.5V444.5L140 457L162.5 462.5L175 432.5V408.5L178.5 394.5L181 404L178.5 419.5V438L166.5 459V476.5H178.5L203.5 483L226.5 488.5L233.5 476.5V465.5L238.5 444.5L246.5 419.5L254 400L268 386.5V373.5Z",
    fill: "url(#paint4_linear_15_97)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M216 496L226.5 488.5L195 480L186.5 477.5L175.5 475H166.5L163 482.5L157.5 492L156 498.5L152.5 509L147 516V524V535V544L144.5 554.5L142.5 563.5L140 574L135 583.5L130.5 598.5L126.5 607L122 619L117.5 629L114.5 636.5L111.5 644.5L106 654.5L99.5 662.5L95 669L88 680.5L81.5 689.5L78 693.5L86.5 696.5L91 701.5H99.5H109L114 696.5L117 689.5L120.5 682L124 674.5L128.5 667L132.5 659L137.5 649L144.5 640.5L150 629L157.5 619L163 609L169.5 598L174 587.5L178.5 576.5L182.5 564.5L186.5 551.5L189 538.5L197 524L202.5 513L210 505L216 496Z",
    fill: "#A1665E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 451V445L128 450L138.5 454L146 457.5L155.5 460.5L162.5 462L159 474.5L154.5 484.5L152.5 495L149.5 502.5L146 513L142 519L138.5 529L135.5 539.5L132 552.5L124.5 572L93 651L91.5 659L93 670.5L85.5 674H78L72.5 670.5L66.5 665.5L58.5 661L63.5 651L66.5 643L69.5 634L72.5 624L75.5 615L78 604L80.5 593.5L83 582.5L85.5 572L89 562.5L93 552.5L95.5 539.5L98.5 529L101 519L103.5 509.5L106 502.5V492.5L109 487L111.5 480.5L115 474.5V465.5L117.5 457.5V451Z",
    fill: "#A1665E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54 667.5L57.5 661.5L69.5 667.5L78 674.5H84.5L91 671.5V674.5L84.5 682.5L78 693.5L69.5 701L65.5 708L57.5 711.5L48.5 717.5L42.5 720.5L32.5 726L20.5 729.5H10.5L3 726L0 720.5L3 715L10.5 708L15 705L20.5 701L25 696.5L30 693.5L35 688L39 682.5L45.5 676.5L48.5 671.5L54 667.5Z",
    fill: "#68F38D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54 667.5L57.5 661.5L69.5 667.5L78 674.5H84.5L91 671.5V674.5L84.5 682.5L78 693.5L69.5 701L65.5 708L57.5 711.5L48.5 717.5L42.5 720.5L32.5 726L20.5 729.5H10.5L3 726L0 720.5L3 715L10.5 708L15 705L20.5 701L25 696.5L30 693.5L35 688L39 682.5L45.5 676.5L48.5 671.5L54 667.5Z",
    fill: "url(#paint5_linear_15_97)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 703.5L78 694L85 695.5L91 701.5H99.5H106.5L112.5 698.5L116.5 692L118.5 694L123 703.5V711.5L124.5 720L118.5 724L110.5 728L103.5 731.5L97.5 737.5L91 742L84 747.5L74 749.5L65.5 754L54 756.5L42.5 759L33 756.5L25 749.5L27.5 742L33 737.5L39.5 734L46 728L54 720L61.5 713.5L69.5 703.5Z",
    fill: "#90EE90"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 703.5L78 694L85 695.5L91 701.5H99.5H106.5L112.5 698.5L116.5 692L118.5 694L123 703.5V711.5L124.5 720L118.5 724L110.5 728L103.5 731.5L97.5 737.5L91 742L84 747.5L74 749.5L65.5 754L54 756.5L42.5 759L33 756.5L25 749.5L27.5 742L33 737.5L39.5 734L46 728L54 720L61.5 713.5L69.5 703.5Z",
    fill: "url(#paint6_linear_15_97)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_97",
    x1: 171.25,
    y1: 8.5,
    x2: 171.25,
    y2: 42.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15_97",
    x1: 205.75,
    y1: 1,
    x2: 205.75,
    y2: 71.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15_97",
    x1: 214.5,
    y1: 99,
    x2: 214.5,
    y2: 351.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#913C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF005C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15_97",
    x1: 61.5,
    y1: 145.5,
    x2: 61.5,
    y2: 189.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15_97",
    x1: 192.5,
    y1: 326.5,
    x2: 192.5,
    y2: 488.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8148FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767D80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15_97",
    x1: 45.5,
    y1: 661.5,
    x2: 45.5,
    y2: 729.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EE90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35D135",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15_97",
    x1: 74.75,
    y1: 692,
    x2: 74.75,
    y2: 759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DD27D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF85",
    stopOpacity: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaningMan);
export default __webpack_public_path__ + "static/media/leaning-man.b506387e81f894da100b7328e79bbea0.svg";
export { ForwardRef as ReactComponent };